const constants = {
    appName : 'Ingenia Rest',
    api : {
        base : 'https://ir.ingeniabit.com'
    },
    hooks : {
        sat  : {
            regimenes : 'regimenes',
            usosCfdi : 'usosCfdi',
            formasPago : 'formasPago'
        }
    },
    themeDefaults : {
        themeMode: 'dark',
        themeDirection: 'ltr',
        themeContrast: 'default',
        themeLayout: 'vertical',
        themeColorPresets: 'red',
        themeStretch: false,
    },
    gmapsKey : 'AIzaSyBUpg_ALxS3rY4boGpCMlif1DPoK76K1UA',
    defaultGps : {
        lat : 19.4356, lng : -99.1439
    },
    openPayMerchantId : 'mwi7gud5mkzzqmkpqafb',
    openpayPk : 'pk_a8ef12ccfa2f4defb51bc22afa753dcf',
    openPaySandbox : 0
}
export { constants }

// PROD : https://ir.ingeniabit.com
// DEV : http://ir-nube.des:82
// DEV SERVER: https://dev-ir-nube.ingeniabit.com
